var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.Translator('admin.notice_collection.facets.most_viewed')))]),_c('ul',_vm._l((_vm.notices),function(notice){return _c('li',{key:notice.id},[_c('a',{attrs:{"href":notice.url}},[_vm._v(" "+_vm._s(notice.titles.title)+" ("+_vm._s(notice.views)+") ")])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }